import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { SignOut, Crosshair } from "@phosphor-icons/react";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-50 border-b border-[#2a2a2a] bg-[#050505]/90 backdrop-blur-md"
    >
      <div className="px-6 py-3 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3 group">
          <div className="w-8 h-8 border border-[#ffb000] flex items-center justify-center text-[#ffb000] group-hover:bg-[#ffb000]/10 transition-colors">
            <Crosshair size={18} weight="bold" />
          </div>
          <div className="leading-tight">
            <div className="text-[#ededed] font-bold tracking-tight text-base">LeadMe<span className="text-[#ffb000]">.ca</span></div>
            <div className="text-[10px] font-mono text-[#888] uppercase tracking-[0.2em]">Show me the Leads</div>
          </div>
        </Link>

        <nav className="flex items-center gap-2">
          <Link
            to="/"
            data-testid="nav-dashboard"
            className={`btn-ghost ${loc.pathname === "/" ? "text-[#ededed] bg-[#111]" : ""}`}
          >
            Dashboard
          </Link>
          {user && user !== false && (
            <>
              <div className="hidden md:flex items-center gap-2 ml-2 pl-3 border-l border-[#2a2a2a]">
                <div className="w-7 h-7 border border-[#2a2a2a] flex items-center justify-center text-[10px] font-mono text-[#ffb000]">
                  {(user.email || "?").charAt(0).toUpperCase()}
                </div>
                <span className="font-mono text-xs text-[#888]">{user.email}</span>
              </div>
              <button
                data-testid="logout-btn"
                onClick={handleLogout}
                className="btn-secondary flex items-center gap-2"
              >
                <SignOut size={14} />
                Logout
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
